export function LoadingState({ label = "正在读取账本…" }: { label?: string }) {
  return (
    <div className="state-card" role="status">
      <span className="spinner" aria-hidden="true" />
      <span>{label}</span>
    </div>
  );
}

export function ErrorState({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <div className="state-card error-state" role="alert">
      <p>{message}</p>
      {onRetry && <button className="secondary-button" onClick={onRetry}>重新加载</button>}
    </div>
  );
}
